import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DomainInfoPanel from '@/components/proficiency/domain-info-panel/domain-info-panel';
import { CompetencyModel } from '@/models/proficiency/competency';
import { DomainModel } from '@/models/proficiency/domain';
import { SubjectModel } from '@/models/taxonomy/subject';
import { ClassificationModel } from '@/models/taxonomy/classification';
import { competencyAPI } from '@/providers/apis/competency/competency';

import { Domain } from '@/models/proficiency/domain-topic/domain';
import { Topic } from '@/models/proficiency/domain-topic/topic';
import { Competency } from '@/models/proficiency/domain-topic/competency';
import axios from 'axios';

@Component({
  name: 'domains-list-panel',
  components: {
    'domain-info-panel': DomainInfoPanel,
  },
})
export default class DomainsListPanel extends Vue {

  get subjectCode() {
    return this.subject ? this.subject.code : 'K12.MA';
  }

  @Prop()
  public classification!: ClassificationModel;

  @Prop()
  private subject!: SubjectModel;

  @Prop()
  private userId!: string;

  private domainMatrix!: any;

  private domainTopicMetadata!: any;

  // @Prop()
  private domainProficiencyData!: Domain[];

  private isShowDomainInfo: boolean = false;

  @Prop()
  private activeDomainInfo!: Domain;

  private isLoading: boolean = false;

  @Prop()
  private month!: string;

  @Prop()
  private year!: string;

  public created() {
    this.loadProficiencyData();
  }

  public onSelectDomain(domain: any) {
    const component = this;
    component.activeDomainInfo = domain;
    component.isShowDomainInfo = true;
    component.$emit('onSelectDomain', domain);
  }

  public onCloseDomainInfoPanel() {
    this.isShowDomainInfo = false;
  }

  @Watch('subject')
  public onChangeSubject() {
    this.loadProficiencyData();
  }

  public loadProficiencyData() {
    const component = this;
    component.isLoading = true;
    axios.all([component.fetchUserDomainTopicCompetencyMatrix(), component.fetchSubjectDomainMetadata()]).then(
      axios.spread((domainMatrix: any, domainTopicMetadata: any) => {
      component.domainMatrix = domainMatrix;
      component.domainTopicMetadata = domainTopicMetadata;
      component.domainProficiencyData = component.parseDomainTopicCompetencyMatrix(domainMatrix, domainTopicMetadata);
      component.isLoading = false;
    }));
  }

  public fetchUserDomainTopicCompetencyMatrix() {
    const params = {
      user: this.userId,
      subject: this.subjectCode,
      month: Number(this.month),
      year: Number(this.year),
    };
    return competencyAPI.fetchDomainTopicCompetencyMatrix(params);
  }

  public fetchSubjectDomainMetadata() {
    const params = {
      subject: this.subjectCode,
    };
    return competencyAPI.fetchSubjectDomainTopicMetadata(params);
  }

  private parseDomainTopicCompetencyMatrix(domainTopicMatrix: Domain[], domainTopicMetadata: Domain[]): Domain[] {
    // console.log('maxDomainSize', this.maxDomainSize);
    const totalCompetencies = 0;
    const chartData = domainTopicMetadata.map((domainMetada: Domain) => {

      const domainMatrix = domainTopicMatrix.find((matrix: Domain) => matrix.domainCode === domainMetada.domainCode);
      const parsedDomainData = {...domainMetada, ...domainMatrix};
      // console.log('parsed domain', parsedDomainData);
      // console.log('domainMatrix', domainMatrix);
      if (domainMatrix && domainMatrix.topics) {
        const parsedDomainTopicData: Topic[] = [];
        domainMatrix.topics.map((topicMatrix: Topic) => {
          const topicMetadata = domainMetada.topics.find((topic: Topic) => topic.topicCode === topicMatrix.topicCode);
          if (topicMatrix.competencies) {
            topicMatrix.competencies.map((competency: Competency) => {
              competency.domainCode = domainMetada.domainCode,
              competency.competencyStatus = competency.status;
              competency.isMastered = competency.status > 1;
              competency.isInferred = competency.status === 2 || competency.status === 3;
              competency.isSkyLineCompetency = false;
              competency.isGradeBoundary = false;
            });
            topicMatrix.competencies[0].isSkyLineCompetency = true;
          }
          parsedDomainTopicData.push({...topicMatrix, ...topicMetadata});
        });
        parsedDomainData.topics = parsedDomainTopicData;
      }

      return parsedDomainData;
    });
    return chartData;
  }

  private onSelectCompetency(competency: any) {
    this.$emit('onSelectCompetency', competency);
  }

  @Watch('month')
  private onChageTimeline() {
    this.loadProficiencyData();
  }

}
